import { Grid, useEventCallback } from '@mui/material';
import { memo } from 'react';
import { FormikErrors, FormikTouched } from 'formik';
import { CommonCivilStatusFormVM } from 'civil-status/view-models/document-birth-form';
import { PmiInputFile } from 'shell/components/shared/file-input';
import { __CIVIL_STATUS_API_URL__ } from 'shell/constants/environment';
import { ResponsePromise } from 'shell/hooks/use-http-fetch/stateless/type';
import { useHttpClient } from 'shell/hooks/use-http-fetch/stateless';
import { PageMode } from 'civil-status/view-models/page-mode';
import { HttpResponse } from 'shell/models/http-response';
import { ConvertedImage } from 'shell/models/convert-image';

interface UploadFileFormProps {
  values?: CommonCivilStatusFormVM;
  errors?: FormikErrors<CommonCivilStatusFormVM>;
  touched?: FormikTouched<CommonCivilStatusFormVM>;
  onChange: (
    key: keyof CommonCivilStatusFormVM,
    value: CommonCivilStatusFormVM[keyof CommonCivilStatusFormVM]
  ) => void;
  mode: PageMode;
}

const UploadFileComponent = ({
  values,
  mode,
  onChange,
}: UploadFileFormProps): React.ReactElement => {
  const convertDocument = useHttpClient<HttpResponse<ConvertedImage>>(
    `${__CIVIL_STATUS_API_URL__}/convert-image`,
    {
      options: {
        errorCatching: true,
        method: 'POST',
        loading: true,
      },
    }
  );

  const handleAddFile = useEventCallback((file: File) => {
    const reader = new FileReader();
    reader.addEventListener('load', (event) => {
      const { result } = event.target || {};
      (
        convertDocument({
          data: {
            formato: 'png',
            immagineIniziale: (result as string)?.split(',')[1],
          },
        }) as ResponsePromise<HttpResponse<ConvertedImage>>
      ).then((response) => {
        onChange('uploadFile', {
          file,
          raw: response?.data?.payload?.immagineConvertita
            ? (response?.data?.payload?.immagineConvertita as Array<string>)?.map(
                (immagine: string) => `data:image/png;base64,${immagine}`
              )
            : [],
          rawTiff: result as string,
        });
      });
    });

    reader.readAsDataURL(file);
  });

  return (
    <>
      {mode === PageMode.Substitution ? (
        <Grid item xs={12}>
          <div>Carica documento&nbsp;</div>
          <PmiInputFile
            accept="image/tiff"
            multiple={false}
            file={values?.uploadFile?.file}
            showFilename
            onChange={handleAddFile}
            color="cdmBrandThird"
            tipMaxSize={350}
          />
        </Grid>
      ) : undefined}
    </>
  );
};

UploadFileComponent.displayName = 'Upload form component';

const UploadFileForm = memo(UploadFileComponent);

export default UploadFileForm;
